// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__3S2vc","rotate_ring":"loading_rotate_ring__BgwWJ","rotate":"loading_rotate__QwO1J"};